const API_URL = "https://ecoconnect-9x9t.onrender.com"
// const API_URL = "http://localhost:5000";
export default API_URL;
